import type { TestNode } from 'components/SecuritySchema/model/SecuritySchemaNode';
import { renderReferenceMetaInfo } from 'components/SecuritySchema/nodeComponents/renderReferenceMetaInfo';
import { renderTestMetaInfo } from 'components/SecuritySchema/nodeComponents/renderTestMetaInfo';
import type { ReactNode } from 'react';
import type { AppTranslations } from 'translations/translations';

export const renderTestNodeMetaInfo = (
  node: TestNode,
  msg: AppTranslations,
): ReactNode => (
  <>
    {node.referenceInfo && renderReferenceMetaInfo(node.referenceInfo, msg)}
    {renderTestMetaInfo(node.info, msg)}
  </>
);
